module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"loginWithGoogle":"Sincronizza Eventi con Google Calendar","googleCalendarConnect":"Google Calendar Connect","CreateAvailableSlotsOnCalendar":"Crea gli slot disponibili su Google Calendar","AvailableSlotsColorId":"Colore slot disponibili","CreateBookingsOnCalendar":"Crea gli eventi su Google Calendar","BookingsColorId":"Colore eventi"}}')
  delete Component.options._Ctor
}
